"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOffchainVotingProof = exports.submitOffchainVotingProof = exports.getApiStatus = exports.getVotes = exports.getSpace = exports.getProposals = exports.getDrafts = exports.submitMessage = exports.buildVoteMessage = exports.buildProposalMessage = exports.buildDraftMessage = void 0;
var axios_1 = __importDefault(require("axios"));
var types_1 = require("./types");
/**
 * ------------------
 * SNAPSHOT HUB UTILS
 * ------------------
 */
var VOTE_CHOICES = [types_1.VoteChoices.Yes, types_1.VoteChoices.No];
var getTimestampSeconds = function () { return Math.floor(Date.now() / 1e3); };
var getVoteChoiceIndex = function (choice) {
    var index = types_1.VoteChoicesIndex[choice];
    if (!index) {
        throw new Error("Could not find vote index.");
    }
    return index;
};
var buildDraftMessage = function (message, snapshotHubURL) { return __awaiter(void 0, void 0, void 0, function () {
    var data, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, exports.getApiStatus(snapshotHubURL)];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, {
                        payload: {
                            body: message.body,
                            choices: VOTE_CHOICES,
                            metadata: message.metadata,
                            name: message.name,
                        },
                        space: message.space,
                        timestamp: getTimestampSeconds().toString(),
                        token: message.token,
                        type: types_1.SnapshotType.draft,
                        version: data.version,
                    }];
            case 2:
                error_1 = _a.sent();
                throw error_1;
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.buildDraftMessage = buildDraftMessage;
var buildProposalMessage = function (message, snapshotHubURL) { return __awaiter(void 0, void 0, void 0, function () {
    var timestamp, voteStartTimestamp, data, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                timestamp = message.timestamp
                    ? parseInt(message.timestamp)
                    : getTimestampSeconds();
                voteStartTimestamp = getTimestampSeconds();
                return [4 /*yield*/, exports.getApiStatus(snapshotHubURL)];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, {
                        payload: {
                            body: message.body,
                            choices: VOTE_CHOICES,
                            end: voteStartTimestamp + message.votingTimeSeconds,
                            metadata: message.metadata,
                            name: message.name,
                            start: voteStartTimestamp,
                            snapshot: message.snapshot,
                        },
                        space: message.space,
                        timestamp: timestamp.toString(),
                        token: message.token,
                        type: types_1.SnapshotType.proposal,
                        version: data.version,
                    }];
            case 2:
                error_2 = _a.sent();
                throw error_2;
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.buildProposalMessage = buildProposalMessage;
var buildVoteMessage = function (vote, proposal, snapshotHubURL) { return __awaiter(void 0, void 0, void 0, function () {
    var timestamp, data, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                timestamp = getTimestampSeconds();
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, exports.getApiStatus(snapshotHubURL)];
            case 2:
                data = (_a.sent()).data;
                return [2 /*return*/, {
                        payload: {
                            choice: getVoteChoiceIndex(vote.choice),
                            proposalId: proposal.proposalId,
                            metadata: vote.metadata,
                        },
                        space: proposal.space,
                        timestamp: timestamp.toString(),
                        token: proposal.token,
                        type: types_1.SnapshotType.vote,
                        version: data.version,
                    }];
            case 3:
                error_3 = _a.sent();
                // Error is an Axios error, so we should just re-create our own simple Error
                throw new Error(error_3.message);
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.buildVoteMessage = buildVoteMessage;
var submitMessage = function (snapshotHubURL, address, message, signature, erc712Data) {
    var data = {
        address: address,
        msg: JSON.stringify(message),
        sig: signature,
        erc712Data: JSON.stringify(erc712Data),
    };
    return axios_1.default.post(snapshotHubURL + "/api/message", data, {
        headers: {
            "Content-Type": "application/json",
        },
    });
};
exports.submitMessage = submitMessage;
var getDrafts = function (snapshotHubURL, space) {
    return axios_1.default.get(snapshotHubURL + "/api/" + space + "/drafts");
};
exports.getDrafts = getDrafts;
var getProposals = function (snapshotHubURL, space) {
    return axios_1.default.get(snapshotHubURL + "/api/" + space + "/proposals");
};
exports.getProposals = getProposals;
var getSpace = function (snapshotHubURL, space) {
    return axios_1.default.get(snapshotHubURL + "/api/spaces/" + space);
};
exports.getSpace = getSpace;
var getVotes = function (snapshotHubURL, space, proposalId) {
    return axios_1.default.get(snapshotHubURL + "/api/" + space + "/proposal/" + proposalId + "/votes");
};
exports.getVotes = getVotes;
var getApiStatus = function (snapshotHubURL) {
    return axios_1.default.get(snapshotHubURL + "/api");
};
exports.getApiStatus = getApiStatus;
/**
 * submitOffchainVotingProof
 *
 * Submits a Merkle hex root and its steps to Snapshot Hub
 * for verification and storage (if successful).
 *
 * The API endpoint does not have any return data, only a `201` response.
 *
 * @link https://github.com/openlawteam/snapshot-hub
 */
function submitOffchainVotingProof(snapshotHubURL, space, data) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, axios_1.default
                    .post(snapshotHubURL + "/api/" + space + "/offchain_proofs", data, {
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                    .then(function (resp) { return resp.data; })
                    .catch(function (err) {
                    var resp = err.response;
                    if (resp.status !== 201) {
                        throw new Error("Something went wrong while submitting the off-chain vote proof.");
                    }
                })];
        });
    });
}
exports.submitOffchainVotingProof = submitOffchainVotingProof;
/**
 * getOffchainVotingProof
 *
 * Gets a Merkle hex root's steps from Snapshot Hub
 * for verification.
 *
 * @link https://github.com/openlawteam/snapshot-hub
 */
function getOffchainVotingProof(snapshotHubURL, space, merkleRootHex) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, axios_1.default
                    .get(snapshotHubURL + "/api/" + space + "/offchain_proof/" + merkleRootHex)
                    .then(function (res) {
                    return res.data;
                })
                    .catch(function (error) {
                    // Return empty if not found
                    if (error.response && error.response.status === 404) {
                        return undefined;
                    }
                    throw new Error("Something went wrong while getting the off-chain vote proof.");
                })];
        });
    });
}
exports.getOffchainVotingProof = getOffchainVotingProof;
